<template>
  <page-outline :title="$t('Webheader.country')">
    <template slot="pageContent">
      <f7-list class="mb-2">
        <f7-list-item>
          <div class="row d-flex">
            <div class="mx-3">
              <b-button class="btn btnFilter"
                :aria-label="$t('common.rfrsh')"
                @click="applyFilter()">
                <i class="fa fa-rotate-right"></i>
              </b-button>
            </div>
            <div>
              <b-button variant="secondary"
                @click="addCountry">
                <i class="fa-light fa-plus"></i>
                <span>{{$t('administration.countries.country_add')}}</span>
              </b-button>
            </div>
          </div>
        </f7-list-item>
      </f7-list>
      <spinner v-if="activateSpinner"></spinner>
      <b-table hover v-else-if="CountryList.length > 0"
      class="table table-striped"
      :key="keyTableCountry"
      :fields="fields"
      :items="CountryList"
      :selectable="CountryList.length > 0"
      empty-text="Pas de résultat"
      @row-selected="seeCountryDetails">
        <template #cell(localBIC)="data">
          <span v-if="data.value === 'MUL'">{{ $t('administration.countries.multiple_bic') }}</span>
          <span v-else-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>
        <template #cell(active)="data">
          <span v-if="data.value === '1'"><i class="fa-light fa-check btn btn-icon btn-icon-green"/></span>
          <span v-else><i class="fa-light fa-times btn btn-icon btn-icon-red"/></span>
        </template>
        <template #cell(EBA)="data">
          <span v-if="data.value"><i class="fa-light fa-check btn btn-icon btn-icon-green"/></span>
          <span v-else><i class="fa-light fa-times btn btn-icon btn-icon-red"/></span>
        </template>
        <template #cell(GIRO)="data">
          <span v-if="data.value"><i class="fa-light fa-check btn btn-icon btn-icon-green"/></span>
          <span v-else><i class="fa-light fa-times btn btn-icon btn-icon-red"/></span>
        </template>
        <template #cell(PSD2)="data">
          <span v-if="data.value"><i class="fa-light fa-check btn btn-icon btn-icon-green"/></span>
          <span v-else><i class="fa-light fa-times btn btn-icon btn-icon-red"/></span>
        </template>
      </b-table>
      <div v-else class="d-flex justify-content-center">
        <span class="noResult">
          {{ $t('common.no_result') }}
        </span>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CountryList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: false,
      CountryList: [],
      keyTableCountry: false
    }
  },
  computed: {
    fields () {
      let fields = [
        { key: 'name', label: this.$i18n.t('administration.name'), class: 'text-center', sortable: true },
        { key: 'active', label: this.$i18n.t('administration.active'), class: 'text-center', sortable: true },
        { key: 'localBIC', label: this.$i18n.t('administration.countries.country_bic'), class: 'text-center', sortable: true },
        { key: 'EBA', label: 'SRTP', class: 'text-center', sortable: true },
        { key: 'GIRO', label: 'GIRO', class: 'text-center', sortable: true },
        { key: 'PSD2', label: 'PSD2', class: 'text-center', sortable: true }
      ]
      return fields
    }
  },
  created () {
    this.applyFilter()
  },
  methods: {
    addCountry () {
      let that = this
      loadPage(that, {url: '/country/form/-1'})
    },
    applyFilter () {
      let that = this
      this.activateSpinner = true
      this.$engine.administration.country.fetch({})
      .then(resp => {
        that.CountryList = resp.data.countries.map(elem => {
          let norms = elem.norms.split(',')
          return {
            idCountry: elem.idCountry,
            active: elem.active,
            name: elem.name,
            localBIC: elem.localBIC,
            numericCode: elem.numericCode,
            EBA: norms.includes('SRTP') || norms.includes('EBA'),
            GIRO: norms.includes('HRTP') || norms.includes('GIRO'),
            PSD2: norms.includes('PSD2')
          }
        })
        that.$engine.administration.country.activeList = that.CountryList
        that.activateSpinner = false
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    seeCountryDetails (items) {
      let that = this
      this.keyTableCountry = !this.keyTableCountry
      this.$engine.administration.country.countryDetails = items[0]
      loadPage(that, {url: '/country/form/' + items[0].idCountry})
    }
  }
}

</script>

<style>
</style>
